/** Milliseconds to wait before sending another update to the database. */
export const THROTTLED_UPDATE_DELAY = 2000;
